"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _withOnClickOutside = _interopRequireDefault(require("./_withOnClickOutside"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var OnClickOutsideWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(OnClickOutsideWrapper, _React$Component);
  var _super = _createSuper(OnClickOutsideWrapper);
  function OnClickOutsideWrapper() {
    (0, _classCallCheck2.default)(this, OnClickOutsideWrapper);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(OnClickOutsideWrapper, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);
  return OnClickOutsideWrapper;
}(_react.default.Component);
OnClickOutsideWrapper.displayName = 'OnClickOutsideWrapper';
OnClickOutsideWrapper.propTypes = {
  children: _propTypes.default.node.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  handleClickOutside: _propTypes.default.func.isRequired
};
var _default = (0, _withOnClickOutside.default)(OnClickOutsideWrapper);
exports.default = _default;